







import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class KvButtonIcon extends Vue {
    @Prop() readonly icon!: string
    @Prop({ type: Boolean, default: false }) readonly grey!: boolean
    @Prop({ type: Boolean, default: false }) readonly green!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    @Prop({ type: Boolean, default: false }) readonly liberty!: boolean
    @Prop({ type: Boolean, default: false }) disabled!: boolean

    get componentClass(): object {
        return {
            'kv-button-icon': true,
            'kv-button-icon--grey': this.grey,
            'kv-button-icon--green': this.green,
            'kv-button-icon--white': this.white,
            'kv-button-icon--liberty': this.liberty,
            'kv-button-icon--disabled': this.disabled,
        }
    }

    onClick($event): void {
        if (this.disabled) {
            return
        }

        this.$emit('click', $event)
    }
}
